import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/ActionTypes'
import { FETCH_MERCHANDISE_ADVERTS } from 'actions/apiActionConstants'
import requestMerchandiseAdverts from 'api/merchandise/requestMerchandiseAdverts'

function fetchMerchandiseAdverts(): AppAction {
  return dispatch => dispatch({
    type: API_CALL,
    api: FETCH_MERCHANDISE_ADVERTS,
    request: () => requestMerchandiseAdverts(),
  })
}

export default fetchMerchandiseAdverts
